(function () {
  Chart.spiralGridHospitals = function (params) {
    const data = params.data;
    const formato = params.formato;
    const el = params.el;
    const partido = params.partido;

    let box = new Box({
      size: { width: 2400, height: 2400 },
      padding: 20,
    });

    let svg = null;
    let gEspiral = null;
    let gLeyenda = null;

    const colorHospitalizacion = d3
      .scaleLinear()
      .domain([1, 6])
      .range(["#fdbaba", "#ff0000"]);

    const formatTime = d3.utcFormat("%d de %B de %Y");

    function setup() {
      let max = _.max(_.map(data, "hospitalizacion"));
      colorHospitalizacion.domain([1, max]);

      crearSVG(el);
      crearEspiral();
      crearLeyenda();
    }

    function crearSVG(wrapper) {
      svg = wrapper
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr("viewBox", `0 0 ${box.width} ${box.height + 200}`);

      svg = svg.append("g");

      svg = svg
        .append("g")
        .attr("transform", `translate(${box.padding.left}, ${box.padding.top})`)
        .style("font-size", "34px");

      gEspiral = svg
        .append("g")
        .attr("data-g", "gEspiral")
        .attr(
          "transform",
          `translate(${box.content.width / 2}, ${box.content.height / 2})`,
        );

      gLeyenda = svg
        .append("g")
        .attr("data-g", "gLeyenda")
        .attr("transform", `translate(100, 100)`);
    }

    function crearEspiral() {
      _.each(data, function (d) {
        let fecha = d.fecha.split("-");
        let anio = +fecha[0];
        let mes = +fecha[1] - 1;
        let dia = +fecha[2];
        d.fecha = new Date(anio, mes, dia);
      });

      let ini = new Date(2018, 0, 1);
      let fin = new Date(2025, 11, 31);
      let fecha = new Date(2018, 0, 1);

      let fechas = [];

      while (fecha <= fin) {
        fecha.setDate(fecha.getDate() + 1);
        let nueva = new Date(fecha);

        let defuncion = null;
        let hospitalizacion = null;
        let obj = _.find(data, { fecha: nueva });
        if (obj) {
          defuncion = obj.defuncion;
          hospitalizacion = obj.hospitalizacion;
        }

        fechas.push({
          fecha: nueva,
          defuncion: defuncion,
          hospitalizacion: hospitalizacion,
        });
      }

      /*
      return 0;

      let arreglo = [];
      let objeto = {};

      let anios = [2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025];
      let meses = [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ];

      _.each(anios, function (a) {
        _.each(meses, function (m) {
          let anio_mes = `${a}-${m}`;
          objeto[anio_mes] = {
            anio_mes: anio_mes,
            anio: +a,
            mes: +m,
            edades: [
              { grupo: "MAYOR", valor: 0 },
              { grupo: "ADULTO", valor: 0 },
              { grupo: "JOVEN", valor: 0 },
            ],
          };
        });
      });

      _.each(data, function (d) {
        if (objeto.hasOwnProperty(d.anio_mes)) {
          let o = _.find(objeto[d.anio_mes].edades, {
            grupo: d.demografia_edad,
          });
          o.valor = d.tasa_defuncion;
        }
      });

      arreglo = _.values(objeto);

      console.log("objeto");
      console.log(objeto);

      console.log("arreglo");
      console.log(arreglo);
      */

      const spiralArc = (fromRadius, toRadius, width, fromAngle, toAngle) => {
        const x1 = fromRadius * Math.sin(fromAngle);
        const y1 = fromRadius * -Math.cos(fromAngle);
        const x2 = (fromRadius + width) * Math.sin(fromAngle);
        const y2 = (fromRadius + width) * -Math.cos(fromAngle);
        const x3 = toRadius * Math.sin(toAngle);
        const y3 = toRadius * -Math.cos(toAngle);
        const x4 = (toRadius + width) * Math.sin(toAngle);
        const y4 = (toRadius + width) * -Math.cos(toAngle);
        return `
    M ${x1},${y1}
    L ${x2},${y2}
    A ${fromRadius},${fromRadius} 1 0 1 ${x4},${y4}
    L ${x3},${y3}
    A ${fromRadius},${fromRadius} 0 0 0 ${x1},${y1}`;
      };

      const WIDTH = 80;
      const BASE_RADIUS = 200;
      const angle = (Math.PI * 2) / 365;
      const RADIUS_SCALE = 0.15;

      let index = 0;
      _.each(fechas, function (o) {
        const fromAngle = angle * index;
        const toAngle = angle * (index + 1);

        let level = 0;

        const fromRadius =
          BASE_RADIUS + index * 2 * RADIUS_SCALE + WIDTH * level;
        const toRadius =
          BASE_RADIUS + (index + 1) * 2 * RADIUS_SCALE + WIDTH * level;
        const path = spiralArc(fromRadius, toRadius, WIDTH, fromAngle, toAngle);
        //const color = `rgb(0,${192 + Math.random() * 64},255)`;
        gEspiral
          .append("path")
          .datum(o)
          .attr("d", path)
          .style(
            "fill",
            o.hospitalizacion
              ? colorHospitalizacion(o.hospitalizacion)
              : "#f0f0f0",
          )
          //.style("fill", "#f0f0f0")
          //.style("stroke", "#d6d5d5")
          //.style("stroke", "#f0f0f0")
          .style("stroke", o.defuncion ? "#000000" : "#d6d5d5")
          .style("stroke-width", o.defuncion ? "4px" : 1)
          .on("mouseover", crearTooltip);
        level++;

        index++;
      });

      /*
      for (let index = 0; index < 8 * 12; index++) {
        const fromAngle = angle * index;
        const toAngle = angle * (index + 1);
        console.log(
          `index: ${index} - fromAngle: ${fromAngle} - toAngle: ${toAngle}`,
        );
        for (let level = 0; level < 5; level++) {
          const fromRadius =
            BASE_RADIUS + index * 2 * RADIUS_SCALE + WIDTH * level;
          const toRadius =
            BASE_RADIUS + (index + 1) * 2 * RADIUS_SCALE + WIDTH * level;
          console.log(`fromRadius: ${fromRadius} - toRadius: ${toRadius}`);
          const path = spiralArc(
            fromRadius,
            toRadius,
            WIDTH,
            fromAngle,
            toAngle,
          );
          const color = `rgb(0,${192 + Math.random() * 64},255)`;
          g.append("path").attr("d", path).style("fill", color);
        }
      }
      */
    }

    function crearTooltip(ev, d) {
      ev.preventDefault();
      let el = d3.select(this).node();
      if (d.defuncion != null || d.hospitalizacion != null) {
        let cadena = `<strong>Fecha</strong>: ${formatTime(new Date(d.fecha))}`;
        if (d.hospitalizacion != null) {
          cadena += `<br><strong>Personas hospitalizadas: </strong>${d.hospitalizacion}`;
        }
        if (d.defuncion != null) {
          cadena += `<br><strong>Defunciones: </strong>${d.defuncion}`;
        }
        tippy(el, {
          content: cadena,
          allowHTML: true,
        });
      }
    }

    function crearLeyenda() {
      let arreglo = colorHospitalizacion.domain();
      arreglo = getEvenlySpread(1, 28, 5);

      let l = 40;
      let espacio = 20;
      let valY = 0;

      gLeyenda
        .append("text")
        .text("Personas hospitalizadas")
        .attr("x", 0)
        .attr("y", valY);

      valY += espacio;

      _.each(arreglo, function (d) {
        let colorRelleno = colorHospitalizacion(d);
        let texto = d;

        gLeyenda
          .append("rect")
          .style("fill", colorRelleno)
          .attr("x", 0)
          .attr("y", valY)
          .attr("width", l)
          .attr("height", l);

        gLeyenda
          .append("text")
          .text(texto)
          .attr("x", l + espacio / 2)
          .attr("y", valY + l / 2 + 3)
          .attr("dominant-baseline", "middle");

        valY += espacio + l;
      });
    }

    function getEvenlySpread(start, end, steps) {
      if (steps < 2) return [start, end];

      const difference = end - start;
      const increment = difference / (steps - 1);
      const result = [];

      for (let i = 0; i < steps; i++) {
        // Push the calculated value, rounding to avoid floating point errors
        result.push(parseInt(start + increment * i));
      }
      return result;
    }

    return setup();
  };
})();
